import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['today']

  connect() {
    this.scrollToToday()
  }

  scrollToToday() {
    if (!this.hasTodayTarget) return
    const scroller = this.element
    const today = this.todayTarget
    const scrollLeft = today.offsetLeft - (scroller.clientWidth / 2) + (today.offsetWidth / 2)
    scroller.scrollLeft = Math.max(0, scrollLeft)
  }
}
